import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import { navy } from '../colors';
/*::
import type { Node } from 'react';

export type IconDirection = 'left' | 'right' | 'top' | 'bottom';

export type IconProps = {|
  color?: string,
  width?: number,
  height?: number,
  direction?: IconDirection,
|}
*/

var WDZ = 24;
var HGT = 24;
var WTH = WDZ / HGT;
var HTW = HGT / WDZ;

var GtArrow = function GtArrow(_ref
/*: $Rest<IconProps, any> */
) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? navy() : _ref$color,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'left' : _ref$direction,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? WDZ / 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? HGT / 10 : _ref$height,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "direction", "width", "height"]);

  var w = width * 10 === WDZ ? height * WTH : width;
  var h = height * 10 === HGT ? width * HTW : height;

  var directionToDegree = function directionToDegree(dir
  /*: IconDirection */
  )
  /*: ?string */
  {
    switch (dir) {
      case 'left':
        return 'rotate(270deg)';

      case 'right':
        return 'rotate(90deg)';

      case 'top':
        return 'rotate(0deg)';

      case 'bottom':
        return 'rotate(180deg)';

      default:
        return 'rotate(0)';
    }
  };

  var innerStyle = {
    clipPath: 'url(#clip-path)'
  };
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 " + WDZ + " " + HGT,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: w + "rem",
      height: h + "rem",
      transform: directionToDegree(direction)
    }
  }, rest), /*#__PURE__*/React.createElement("g", {
    id: "Group_10272",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10276",
    transform: "translate(0 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10273",
    style: innerStyle
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10272-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25242",
    fill: "none",
    stroke: "rgba(112,112,112,0.01)",
    strokeWidth: "0px",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10275",
    style: innerStyle
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25244",
    fill: color // eslint-disable-next-line max-len
    ,
    d: "M.75 17.939a.743.743 0 0 1-.53-.22.752.752 0 0 1 0-1.061L10.94 5.94a1.5 1.5 0 0 1 2.119 0L23.78 16.658a.752.752 0 0 1 0 1.061.748.748 0 0 1-1.06 0L12 7 1.28 17.719a.743.743 0 0 1-.53.22z"
  }))))));
};

export default GtArrow;